<template>
    <div class="iconview">
      <img  :src="'/svgfiles/'+svgname+'.svg'" :style="{'width':size+'px','height':size+'px'}"/>
      
    </div>
  </template>
  
  <script>
  export default {
    name: 'SvgImage',
    props:{
        size:{
            type:Number,
            default:20
        },
        svgname:{
            type:String,
            default:"ic_book"
        },
        
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  .iconview{
    display: inline-flex;
    overflow: hidden;
  }
  </style>
  